import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const etsy = defineConnector({
  identifier: "etsy",
  name: "Etsy",
  tagLine: "Marketplace for handmade goods",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://openapi\\.etsy\\.com/.*",
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API keystring",
      items: [
        {
          kind: "markdown",
          content:
            "Register an app in the [Etsy developer portal](https://www.etsy.com/developers/your-apps) and copy its keystring. Public endpoints work with the keystring alone; member-specific endpoints additionally require OAuth, which this connector doesn’t perform.",
        },
      ],
    },
    {
      title: "Paste your keystring",
      items: [
        {
          kind: "input",
          label: "API keystring",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://openapi.etsy.com/v3/application/openapi-ping",
  },
});
